var map = {
	"./MapPicsAcropolis.webp": "2e47",
	"./MapPicsArabia.webp": "5859",
	"./MapPicsBabylonianBasin.webp": "792b",
	"./MapPicsBanditCanyon.webp": "b7d9",
	"./MapPicsBanditHideout.webp": "18f2",
	"./MapPicsBigIsland.webp": "0ddc",
	"./MapPicsBlackForest.webp": "ccbb",
	"./MapPicsCampLagoon.webp": "7c2b",
	"./MapPicsCoastal.webp": "8a03",
	"./MapPicsDuelingIslands.webp": "90b6",
	"./MapPicsEqualFooting.webp": "9cc8",
	"./MapPicsFourLakes.webp": "5925",
	"./MapPicsGhostLake.webp": "a46a",
	"./MapPicsGrasslands.webp": "05b5",
	"./MapPicsGreatLake.webp": "86e3",
	"./MapPicsHillfort.webp": "cca5",
	"./MapPicsInland.webp": "7bc5",
	"./MapPicsLowlandGroves.webp": "1fe7",
	"./MapPicsMarshlands.webp": "dc8e",
	"./MapPicsMountainCrossing.webp": "1df5",
	"./MapPicsNewInland.webp": "ae96",
	"./MapPicsOasis.webp": "df62",
	"./MapPicsOverpass.webp": "9ae8",
	"./MapPicsPersianQuarries.webp": "39e8",
	"./MapPicsRiverNile.webp": "edf8",
	"./MapPicsSavannah.webp": "5f18",
	"./MapPicsShelteredPass.webp": "6a30",
	"./MapPicsSpiralValley.webp": "4382",
	"./MapPicsSwampPass.webp": "d31c",
	"./MapPicsTeutoburgForest.webp": "9f3f",
	"./MapPicsTreasureIsland.webp": "c85f",
	"./MapPicsTundra.webp": "04b3",
	"./MapPicsTwizzletopMountain.webp": "5f71b",
	"./MapPicsWateringHole.webp": "0ad1",
	"./MapPicsWildwoods.webp": "3096"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46ef";